import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

// Mismo borde, radio, fuente y placeholder que los inputs del tema
const TextAreaFieldStyled = styled.div`
  textarea {
    min-height: 40px;
    background: ${color.background.default};
    border: 1.5px solid ${color.border.default};
    box-sizing: border-box;
    border-radius: 8px;
    padding: 10px 14px;
    font-family: ${tokens.typography.fontFamily.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
    color: ${color.text.primary};
    outline: none;
    width: 100%;
    resize: none;
    transition: border-color 0.2s ease;

    :hover,
    :focus {
      border-color: ${props => props.theme.primary || color.brand.primary};
    }

    ::placeholder {
      font-weight: 400;
      font-size: 14px;
      color: ${color.text.disabled};
    }
  }
`

export default TextAreaFieldStyled
